import React from 'react';
import PropTypes from 'prop-types';
import { classes } from './styles/provision-lease';
import { Col, Row, FormGroup, Label, Input } from 'reactstrap';
import { translate } from 'react-i18next';
import DateTimeInput from '../common/datetime-input';

class ProvisionLease extends React.Component {

  render() {
    const {
      t,
      jurisdiction,
      systemStatus,
      paidThrough,
      onJurisdiction,
      onSystemStatus,
      onPaidThrough,
      jurisdictions,
      systemStatuses,
      disabled
    } = this.props;
    const getFieldProps = (value, fn) => ({
      value: value || '',
      onChange: (event) => fn(event.target.value)
    });
    return (
      <React.Fragment>
        <div className={classes.titleContainer}>
          <h6 className={classes.title}>{t('provisionLease.title')}</h6>
        </div>
        <Row>
          <Col md={4}>
            <FormGroup>
              <Label for="provision_jurisdiction">{t('provisionLease.jurisdictionLabel')}</Label>
              <Input
                type="select"
                name="provision_jurisdiction"
                id="provision_jurisdiction"
                disabled={disabled}
                {...getFieldProps(jurisdiction, onJurisdiction)}
              >
                <option value="" disabled>{t('provisionLease.jurisdictionPlaceholder')}</option>
                {
                  jurisdictions
                    .map(
                      ({ key, name }, index) => <option value={key} key={index}>{name}</option>
                    )
                }
              </Input>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="provision_systemStatus">{t('provisionLease.systemStatusLabel')}</Label>
              <Input
                type="select"
                name="provision_systemStatus"
                id="provision_systemStatus"
                disabled={disabled}
                {...getFieldProps(systemStatus, onSystemStatus)}
              >
                <option value="" disabled>{t('provisionLease.systemStatusPlaceholder')}</option>
                {
                  systemStatuses
                    .map(
                      (name, index) => <option value={name} key={index}>{name}</option>
                    )
                }
              </Input>
            </FormGroup>
          </Col>
          <Col md={4}>
            <FormGroup>
              <Label for="provision_paidThrough">{t('provisionLease.paidThroughLabel')}</Label>
              <DateTimeInput
                name="provision_paidThrough"
                id="provision_paidThrough"
                placeholder={t('provisionLease.paidThroughPlaceholder')}
                disabled={disabled}
                value={paidThrough}
                onChangeValue={onPaidThrough}
              />
            </FormGroup>
          </Col>
        </Row>
      </React.Fragment>
    )
  }

}

ProvisionLease.propTypes = {
  jurisdiction: PropTypes.string.isRequired,
  systemStatus: PropTypes.string.isRequired,
  paidThrough: PropTypes.number.isRequired,
  onJurisdiction: PropTypes.func.isRequired,
  onSystemStatus: PropTypes.func.isRequired,
  onPaidThrough: PropTypes.func.isRequired,
  jurisdictions: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    }).isRequired
  ),
  systemStatuses: PropTypes.arrayOf(
    PropTypes.string.isRequired
  ),
  disabled: PropTypes.bool
};

export default translate(['pending'])(ProvisionLease);


// WEBPACK FOOTER //
// ./src/views/pending-product-instance/provision-lease.js